angular.module("ainapp")
    .controller("AgingAnalysisCreditorsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Aging Analysis Creditors";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.ParentList = [];
            MainService.GetCustomerParentList().then(function (response) {
                $scope.ParentList = response.data;
            });

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    BranchId: "",
                    Keyword: "",
                    AccountParentId: "",
                    CustomerIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                }

                $scope.load = false;
                $scope.isFilter = false;

            }
            $scope.Init();



            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.accountInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };



            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.Keyword = $scope.filter.Keyword;
                            o.data.ProductId = $scope.filter.ProductId;
                            o.data.BranchId = $scope.filter.BranchId;
                            o.data.AccountParentId = $scope.filter.AccountParentId;

                            MainService.AgingAnalysisCreditorsReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }



                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            INVNo: {
                                type: "string",
                                editable: false,
                            },
                            INVType: {
                                type: "string",
                                editable: false,
                            },

                            "Account.Name": {
                                type: "string",
                                editable: false,
                            },
                            INVID: {
                                type: "number",
                                editable: false,
                            },
                            TotalAmount: {
                                type: "number",
                                editable: false,
                            },
                            TotalPaid: {
                                type: "number",
                                editable: false,
                            },
                            BalanceAmount: {
                                type: "number",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            BillDate: {
                                type: "date",
                                editable: false,
                            },
                            DueDate: {
                                type: "date",
                                editable: false,
                            },
                            BillNo: {
                                type: "string",
                                editable: false,
                            },

                            Amount: {
                                type: "number",
                                editable: false,
                            },
                            Date1: {
                                type: "number",
                                editable: false,
                            },
                            Date2: {
                                type: "number",
                                editable: false,
                            },
                            Date3: {
                                type: "number",
                                editable: false,
                            },
                            Date4: {
                                type: "number",
                                editable: false,
                            },
                            Date5: {
                                type: "number",
                                editable: false,
                            },
                            Date0: {
                                type: "number",
                                editable: false,
                            },
                            DueDays: {
                                type: "number",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                //pageSize: 20,
                group: [{
                    field: "Account.Name",
                    aggregates: [
                        {
                            field: "Date0",
                            aggregate: "sum"
                        }, {
                            field: "Date1",
                            aggregate: "sum"
                        },
                        {
                            field: "Date2",
                            aggregate: "sum"
                        },
                        {
                            field: "Date3",
                            aggregate: "sum"
                        },
                        {
                            field: "Date4",
                            aggregate: "sum"
                        },
                        {
                            field: "Date5",
                            aggregate: "sum"
                        },
                        {
                            field: "BalanceAmount",
                            aggregate: "sum"
                        },
                        ]
                    }],
                aggregate: [
                    {
                        field: "Date0",
                        aggregate: "sum"
                        }, {
                        field: "Date1",
                        aggregate: "sum"
                        },
                    {
                        field: "Date2",
                        aggregate: "sum"
                        },
                    {
                        field: "Date3",
                        aggregate: "sum"
                        },
                    {
                        field: "Date4",
                        aggregate: "sum"
                        },
                    {
                        field: "Date5",
                        aggregate: "sum"
                        },
                    {
                        field: "BalanceAmount",
                        aggregate: "sum"
                        },
                    ],
            });

            $scope.KendoGridOptions = {


                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "Account.Name",
                        title: "Account",
                        width: "250px",
                        hidden: true,
                   },
                    {
                        field: "INVNo",
                        title: "Doc No #",
                        width: "100px",
                        },
                    {
                        field: "INVType",
                        title: "Type",
                        width: "100px",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
//                    {
//                        field: "BillNo",
//                        title: "PO No",
//                        width: "100px",
//                        },
//                    {
//                        field: "BillDate",
//                        title: "Due Date",
//                        template: "#= kendo.toString(kendo.parseDate(BillDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
//                        width: "120px",
//                        },


//                    {
//                        field: "TotalAmount",
//                        title: "Total Amount",
//                        template: "<div style='text-align: right'>#=kendo.toString(TotalAmount, 'n')#</div>",
//                        width: "100px",
//                        headerTemplate: kendo.template("<div class='headerright'>Total Amount</div>"),
//                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
//                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
//                                            },
//                    {
//                        field: "TotalPaid",
//                        title: "Total Paid",
//                        template: "<div style='text-align: right'>#=kendo.toString(TotalPaid, 'n')#</div>",
//                        width: "100px",
//                        headerTemplate: kendo.template("<div class='headerright'>Total Paid</div>"),
//                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
//                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
//                                            },
                    {
                        field: "BalanceAmount",
                        title: "Balance Amount",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Balance Amount</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "DueDate",
                        title: "Due Date",
                        template: '<span>{{dataItem.DueDate | date: "dd/MM/yyyy"}}</span>',
                        width: "120px",
                        },



                    {
                        field: "Date0",
                        title: "Over Due",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date0, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Over Due</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },
                    {
                        field: "DueDays",
                        title: "Due Days",
                        width: "100px",
                        },


                    {
                        field: "Date1",
                        title: "0-30",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date1, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>0-30</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "Date2",
                        title: "31-60",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date2, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>31-60</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "Date3",
                        title: "61-90",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date3, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>61-90</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "Date4",
                        title: "91-120",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date4, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>91-120</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "Date5",
                        title: ">120",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Date5, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>>120</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },


                    ],
            };



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                MainService.PrintBillWiseOutStandingReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }




            }])
